import React, { useEffect } from 'react';
import { Form, Input, Modal, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getCountries } from '../../store/actions/country';

const StateForm = ({ visible, onCreate, onCancel, record }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const countryList = useSelector((state) => state.country.list);

  useEffect(() => {
    // Fetch brands on component mount
    dispatch(getCountries());
  }, [dispatch]);

  useEffect(() => {
    if (record) {
      form.setFieldsValue({
        name: record.name,
        coId: record.coId,
        code: record.code,
      });
    }
    else {
      // Reset form when record is null (for adding new state)
      form.resetFields();
    }
  }, [record, form]);

  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

  return (
    <Modal
      visible={visible}
      title={record ? "Update State" : "Add State"}
      okText="Submit"
      cancelText="Cancel"
      // onCancel={onCancel}
      onCancel={() => {
        form.resetFields(); // Reset form fields when modal is closed
        onCancel(); // Call the onCancel handler
      }}
      onOk={() => {
        form
          .validateFields()
          .then(values => {
            onCreate(values);
            form.resetFields();
          })
          .catch(info => {
            console.log('Validate Failed:', info);
          });
      }}
      width={800}
    >
      <Form
        form={form}
        layout="vertical"
        name="model_form"
        initialValues={record}
      >
        <Form.Item
          name="coId"
          label="Country"
          rules={[{ required: true, message: 'Please select a country!' }]}
        >
          <Select placeholder="Select a country" onChange={handleChange}>
            {countryList.map((country) => (
              <Select.Option key={country.id} value={country.id}>
                {country.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Please enter the model name!' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="code"
          label="Code"
          rules={[{ required: true, message: 'Please enter the model code!' }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default StateForm;